import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { withPrice } from "./withPrice"

const Wrapper = tw.span``
const Money = styled.span`
  ${({ sale }) => sale && tw`text-dark font-medium`}
  ${({ layout }) => {
    if (layout === `product`) return tw`mt-0 mr-1`
    if (layout === `cart`) return tw`ml-0-4 mr-1`
    if (layout === `quiz`) return tw`mt-0-4 mr-1`
    if (layout === `collection`) return tw`mt-0`
    else return tw`mt-0-2`
  }}
`
const SalePrice = tw.span`text-price`

export const Price = withPrice(({ onSale, price, comparedPrice, layout, className }) =>
  !onSale ? (
    <Wrapper layout={layout}>
      <Money className={className} sale={onSale} layout={layout}>
        {price}
      </Money>
      {comparedPrice ? (
        <Money className={className} layout={layout}>
          <s>{comparedPrice}</s>
        </Money>
      ) : null}
    </Wrapper>
  ) : (
    <Money className={className}>
      <s>{comparedPrice}</s> <SalePrice>{price}</SalePrice>
    </Money>
  )
)
